import React from 'react';
import './Loading.css';

function Loading({ page, text, size = 'md' }) {
  if (page) {
    return (
      <div className="loading-page">
        <div className={'loading-spinner ' + size}><div className="spinner-ring" /></div>
        {text && <p>{text}</p>}
      </div>
    );
  }
  return <div className={'loading-spinner ' + size}><div className="spinner-ring" /></div>;
}

export const LoadingSkeleton = ({ type = 'card' }) => {
  if (type === 'card' || type === 'compact-card') {
    return (
      <div className={`event-card-skeleton ${type === 'compact-card' ? 'event-card-skeleton-compact' : ''}`.trim()}>
        <div className="skeleton skeleton-image" />
        <div className="skeleton-content">
          <div className="skeleton" style={{ height: 20, width: '60%' }} />
          <div className="skeleton" style={{ height: 16, width: '80%' }} />
          <div className="skeleton" style={{ height: 16, width: '40%' }} />
          <div className="skeleton-footer">
            <div className="skeleton" style={{ height: 20, width: 60 }} />
            <div className="skeleton" style={{ height: 20, width: 80 }} />
          </div>
        </div>
      </div>
    );
  }
  return <div className="skeleton" style={{ height: 200 }} />;
};

export default Loading;
